var _classCallCheck = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _toConsumableArray = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/Users/dunja/Documents/code/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
/**
 * @name string-remove-thousand-separators
 * @fileoverview Detects and removes thousand separators (dot/comma/quote/space) from string-type digits
 * @version 5.1.0
 * @author Roy Revelt, Codsen Ltd
 * @license MIT
 * {@link https://codsen.com/os/string-remove-thousand-separators/}
 */

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? r(exports) : "function" == typeof define && define.amd ? define(["exports"], r) : r((e = "undefined" != typeof globalThis ? globalThis : e || self).stringRemoveThousandSeparators = {});
}(this, function (e) {
  "use strict";

  /**
   * @name ranges-sort
   * @fileoverview Sort string index ranges
   * @version 4.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/ranges-sort/}
   */
  var r = {
    strictlyTwoElementsInRangeArrays: !1,
    progressFn: null
  };
  function t(e, t) {
    if (!Array.isArray(e) || !e.length) return e;
    var n = _objectSpread({}, r, t);
    var s, i;
    if (n.strictlyTwoElementsInRangeArrays && !e.filter(function (e) {
      return e;
    }).every(function (e, r) {
      return 2 === e.length || (s = r, i = e.length, !1);
    })) throw new TypeError("ranges-sort: [THROW_ID_03] The first argument should be an array and must consist of arrays which are natural number indexes representing TWO string index ranges. However, ".concat(s, "th range (").concat(JSON.stringify(e[s], null, 4), ") has not two but ").concat(i, " elements!"));
    if (!e.filter(function (e) {
      return e;
    }).every(function (e, r) {
      return !(!Number.isInteger(e[0]) || e[0] < 0 || !Number.isInteger(e[1]) || e[1] < 0) || (s = r, !1);
    })) throw new TypeError("ranges-sort: [THROW_ID_04] The first argument should be an array and must consist of arrays which are natural number indexes representing string index ranges. However, ".concat(s, "th range (").concat(JSON.stringify(e[s], null, 4), ") does not consist of only natural numbers!"));
    var o = Math.pow(e.filter(function (e) {
      return e;
    }).length, 2);
    var a = 0;
    return Array.from(e).filter(function (e) {
      return e;
    }).sort(function (e, r) {
      return n.progressFn && (a += 1, n.progressFn(Math.floor(100 * a / o))), e[0] === r[0] ? e[1] < r[1] ? -1 : e[1] > r[1] ? 1 : 0 : e[0] < r[0] ? -1 : 1;
    });
  }
  /**
   * @name ranges-merge
   * @fileoverview Merge and sort string index ranges
   * @version 7.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/ranges-merge/}
   */
  var n = {
    mergeType: 1,
    progressFn: null,
    joinRangesThatTouchEdges: !0
  };
  function s(e, r) {
    function s(e) {
      return e && "object" == typeof e && !Array.isArray(e);
    }
    if (!Array.isArray(e) || !e.length) return null;
    var i;
    if (r) {
      if (!s(r)) throw new Error("emlint: [THROW_ID_03] the second input argument must be a plain object. It was given as:\n".concat(JSON.stringify(r, null, 4), " (type ").concat(typeof r, ")"));
      if (i = _objectSpread({}, n, r), i.progressFn && s(i.progressFn) && !Object.keys(i.progressFn).length) i.progressFn = null;else if (i.progressFn && "function" != typeof i.progressFn) throw new Error("ranges-merge: [THROW_ID_01] opts.progressFn must be a function! It was given of a type: \"".concat(typeof i.progressFn, "\", equal to ").concat(JSON.stringify(i.progressFn, null, 4)));
      if (i.mergeType && 1 != +i.mergeType && 2 != +i.mergeType) throw new Error("ranges-merge: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: \"".concat(typeof i.mergeType, "\", equal to ").concat(JSON.stringify(i.mergeType, null, 4)));
      if ("boolean" != typeof i.joinRangesThatTouchEdges) throw new Error("ranges-merge: [THROW_ID_04] opts.joinRangesThatTouchEdges was customised to a wrong thing! It was given of a type: \"".concat(typeof i.joinRangesThatTouchEdges, "\", equal to ").concat(JSON.stringify(i.joinRangesThatTouchEdges, null, 4)));
    } else i = _objectSpread({}, n);
    var o = e.filter(function (e) {
      return e;
    }).map(function (e) {
      return _toConsumableArray(e);
    }).filter(function (e) {
      return void 0 !== e[2] || e[0] !== e[1];
    });
    var a, u, l;
    if (a = i.progressFn ? t(o, {
      progressFn: function progressFn(e) {
        l = Math.floor(e / 5), l !== u && (u = l, i.progressFn(l));
      }
    }) : t(o), !a) return null;
    var f = a.length - 1;
    for (var _e = f; _e > 0; _e--) i.progressFn && (l = Math.floor(78 * (1 - _e / f)) + 21, l !== u && l > u && (u = l, i.progressFn(l))), (a[_e][0] <= a[_e - 1][0] || !i.joinRangesThatTouchEdges && a[_e][0] < a[_e - 1][1] || i.joinRangesThatTouchEdges && a[_e][0] <= a[_e - 1][1]) && (a[_e - 1][0] = Math.min(a[_e][0], a[_e - 1][0]), a[_e - 1][1] = Math.max(a[_e][1], a[_e - 1][1]), void 0 !== a[_e][2] && (a[_e - 1][0] >= a[_e][0] || a[_e - 1][1] <= a[_e][1]) && null !== a[_e - 1][2] && (null === a[_e][2] && null !== a[_e - 1][2] ? a[_e - 1][2] = null : null != a[_e - 1][2] ? 2 == +i.mergeType && a[_e - 1][0] === a[_e][0] ? a[_e - 1][2] = a[_e][2] : a[_e - 1][2] += a[_e][2] : a[_e - 1][2] = a[_e][2]), a.splice(_e, 1), _e = a.length);
    return a.length ? a : null;
  }
  /**
   * @name ranges-apply
   * @fileoverview Take an array of string index ranges, delete/replace the string according to them
   * @version 5.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/ranges-apply/}
   */
  /**
   * @name string-collapse-leading-whitespace
   * @fileoverview Collapse the leading and trailing whitespace of a string
   * @version 5.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/string-collapse-leading-whitespace/}
   */
  function i(e) {
    var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    function t(e) {
      return Array.from(e).reverse().join("");
    }
    function n(e, r, t) {
      var n = t ? "\n" : "\r",
        s = t ? "\r" : "\n";
      if (!e) return e;
      var i = 0,
        o = "";
      for (var _t = 0, _a = e.length; _t < _a; _t++) (e[_t] === n || e[_t] === s && e[_t - 1] !== n) && i++, "\r\n".includes(e[_t]) || " " === e[_t] ? " " === e[_t] ? o += e[_t] : e[_t] === n ? i <= r && (o += e[_t], e[_t + 1] === s && (o += e[_t + 1], _t++)) : e[_t] === s && (!e[_t - 1] || e[_t - 1] !== n) && i <= r && (o += e[_t]) : e[_t + 1] || i || (o += " ");
      return o;
    }
    if ("string" == typeof e && e.length) {
      var _s = 1;
      "number" == typeof +r && Number.isInteger(+r) && +r >= 0 && (_s = +r);
      var _i = "",
        _o = "";
      if (e.trim()) {
        if (!e[0].trim()) for (var _r = 0, _t2 = e.length; _r < _t2; _r++) if (e[_r].trim()) {
          _i = e.slice(0, _r);
          break;
        }
      } else _i = e;
      if (e.trim() && ("" === e.slice(-1).trim() || " " === e.slice(-1))) for (var _r2 = e.length; _r2--;) if (e[_r2].trim()) {
        _o = e.slice(_r2 + 1);
        break;
      }
      return "".concat(n(_i, _s, !1)).concat(e.trim()).concat(t(n(t(_o), _s, !0)));
    }
    return e;
  }
  /**
   * @name ranges-push
   * @fileoverview Gather string index ranges
   * @version 5.1.0
   * @author Roy Revelt, Codsen Ltd
   * @license MIT
   * {@link https://codsen.com/os/ranges-push/}
   */
  function o(e) {
    return null != e;
  }
  function a(e) {
    return Number.isInteger(e) && e >= 0;
  }
  function u(e) {
    return "string" == typeof e;
  }
  var l = {
    limitToBeAddedWhitespace: !1,
    limitLinebreaksCount: 1,
    mergeType: 1
  };
  var f = /*#__PURE__*/function () {
    function f(e) {
      _classCallCheck(this, f);
      var r = _objectSpread({}, l, e);
      if (r.mergeType && 1 !== r.mergeType && 2 !== r.mergeType) if (u(r.mergeType) && "1" === r.mergeType.trim()) r.mergeType = 1;else {
        if (!u(r.mergeType) || "2" !== r.mergeType.trim()) throw new Error("ranges-push: [THROW_ID_02] opts.mergeType was customised to a wrong thing! It was given of a type: \"".concat(typeof r.mergeType, "\", equal to ").concat(JSON.stringify(r.mergeType, null, 4)));
        r.mergeType = 2;
      }
      this.opts = r, this.ranges = [];
    }
    _createClass(f, [{
      key: "add",
      value: function add(e, r, t) {
        var _this = this;
        if (null == e && null == r) return;
        if (o(e) && !o(r)) {
          if (Array.isArray(e)) {
            if (e.length) {
              if (e.some(function (e) {
                return Array.isArray(e);
              })) return void e.forEach(function (e) {
                Array.isArray(e) && _this.add.apply(_this, _toConsumableArray(e));
              });
              e.length && a(+e[0]) && a(+e[1]) && this.add.apply(this, _toConsumableArray(e));
            }
            return;
          }
          throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_12] the first input argument, \"from\" is set (".concat(JSON.stringify(e, null, 0), ") but second-one, \"to\" is not (").concat(JSON.stringify(r, null, 0), ")"));
        }
        if (!o(e) && o(r)) throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_13] the second input argument, \"to\" is set (".concat(JSON.stringify(r, null, 0), ") but first-one, \"from\" is not (").concat(JSON.stringify(e, null, 0), ")"));
        var n = +e,
          s = +r;
        if (a(t) && (t = String(t)), !a(n) || !a(s)) throw a(n) && n >= 0 ? new TypeError("ranges-push/Ranges/add(): [THROW_ID_10] \"to\" value, the second input argument, must be a natural number or zero! Currently it's of a type \"".concat(typeof s, "\" equal to: ").concat(JSON.stringify(s, null, 4))) : new TypeError("ranges-push/Ranges/add(): [THROW_ID_09] \"from\" value, the first input argument, must be a natural number or zero! Currently it's of a type \"".concat(typeof n, "\" equal to: ").concat(JSON.stringify(n, null, 4)));
        if (o(t) && !u(t) && !a(t)) throw new TypeError("ranges-push/Ranges/add(): [THROW_ID_08] The third argument, the value to add, was given not as string but ".concat(typeof t, ", equal to:\n").concat(JSON.stringify(t, null, 4)));
        if (o(this.ranges) && Array.isArray(this.last()) && n === this.last()[1]) {
          if (this.last()[1] = s, this.last(), null !== this.last()[2] && o(t)) {
            var _e2 = !(this.last()[2] && this.last()[2].length > 0) || this.opts && this.opts.mergeType && 1 !== this.opts.mergeType ? t : this.last()[2] + t;
            this.opts.limitToBeAddedWhitespace && (_e2 = i(_e2, this.opts.limitLinebreaksCount)), u(_e2) && !_e2.length || (this.last()[2] = _e2);
          }
        } else {
          this.ranges || (this.ranges = []);
          var _e3 = void 0 === t || u(t) && !t.length ? [n, s] : [n, s, t && this.opts.limitToBeAddedWhitespace ? i(t, this.opts.limitLinebreaksCount) : t];
          this.ranges.push(_e3);
        }
      }
    }, {
      key: "push",
      value: function push(e, r, t) {
        this.add(e, r, t);
      }
    }, {
      key: "current",
      value: function current() {
        var _this2 = this;
        return Array.isArray(this.ranges) && this.ranges.length ? (this.ranges = s(this.ranges, {
          mergeType: this.opts.mergeType
        }), this.ranges && this.opts.limitToBeAddedWhitespace ? this.ranges.map(function (e) {
          return o(e[2]) ? [e[0], e[1], i(e[2], _this2.opts.limitLinebreaksCount)] : e;
        }) : this.ranges) : null;
      }
    }, {
      key: "wipe",
      value: function wipe() {
        this.ranges = [];
      }
    }, {
      key: "replace",
      value: function replace(e) {
        if (Array.isArray(e) && e.length) {
          if (!Array.isArray(e[0]) || !a(e[0][0])) throw new Error("ranges-push/Ranges/replace(): [THROW_ID_11] Single range was given but we expected array of arrays! The first element, ".concat(JSON.stringify(e[0], null, 4), " should be an array and its first element should be an integer, a string index."));
          this.ranges = Array.from(e);
        } else this.ranges = [];
      }
    }, {
      key: "last",
      value: function last() {
        return Array.isArray(this.ranges) && this.ranges.length ? this.ranges[this.ranges.length - 1] : null;
      }
    }]);
    return f;
  }();
  var g = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
    p = "[object Symbol]",
    y = /^\s+|\s+$/g,
    h = "\\u0300-\\u036f\\ufe20-\\ufe23",
    d = "[\\ud800-\\udfff]",
    m = "[" + h + "\\u20d0-\\u20f0]",
    c = "\\ud83c[\\udffb-\\udfff]",
    T = "[^\\ud800-\\udfff]",
    b = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    w = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    O = "(?:" + m + "|" + c + ")" + "?",
    $ = "[\\ufe0e\\ufe0f]?",
    v = $ + O + ("(?:\\u200d(?:" + [T, b, w].join("|") + ")" + $ + O + ")*"),
    _ = "(?:" + [T + m + "?", m, b, w, d].join("|") + ")",
    S = RegExp(c + "(?=" + c + ")|" + _ + v, "g"),
    I = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0\\ufe0e\\ufe0f]"),
    A = "object" == typeof self && self && self.Object === Object && self,
    N = "object" == typeof g && g && g.Object === Object && g || A || Function("return this")();
  function R(e, r, t) {
    if (r != r) return function (e, r, t, n) {
      for (var s = e.length, i = t + (n ? 1 : -1); n ? i-- : ++i < s;) if (r(e[i], i, e)) return i;
      return -1;
    }(e, E, t);
    for (var n = t - 1, s = e.length; ++n < s;) if (e[n] === r) return n;
    return -1;
  }
  function E(e) {
    return e != e;
  }
  function j(e) {
    return function (e) {
      return I.test(e);
    }(e) ? function (e) {
      return e.match(S) || [];
    }(e) : function (e) {
      return e.split("");
    }(e);
  }
  var W = Object.prototype.toString,
    F = N.Symbol,
    J = F ? F.prototype : void 0,
    D = J ? J.toString : void 0;
  function H(e) {
    if ("string" == typeof e) return e;
    if (function (e) {
      return "symbol" == typeof e || function (e) {
        return !!e && "object" == typeof e;
      }(e) && W.call(e) == p;
    }(e)) return D ? D.call(e) : "";
    var r = e + "";
    return "0" == r && 1 / e == -Infinity ? "-0" : r;
  }
  function q(e, r, t) {
    var n = e.length;
    return t = void 0 === t ? n : t, !r && t >= n ? e : function (e, r, t) {
      var n = -1,
        s = e.length;
      r < 0 && (r = -r > s ? 0 : s + r), (t = t > s ? s : t) < 0 && (t += s), s = r > t ? 0 : t - r >>> 0, r >>>= 0;
      for (var i = Array(s); ++n < s;) i[n] = e[n + r];
      return i;
    }(e, r, t);
  }
  var x = function x(e, r, t) {
    var n;
    if ((e = null == (n = e) ? "" : H(n)) && (t || void 0 === r)) return e.replace(y, "");
    if (!e || !(r = H(r))) return e;
    var s = j(e),
      i = j(r);
    return q(s, function (e, r) {
      for (var t = -1, n = e.length; ++t < n && R(r, e[t], 0) > -1;);
      return t;
    }(s, i), function (e, r) {
      for (var t = e.length; t-- && R(r, e[t], 0) > -1;);
      return t;
    }(s, i) + 1).join("");
  };
  e.remSep = function (e, r) {
    var t = !0;
    var n = [".", ",", "'", " "];
    var i;
    if ("string" != typeof e) throw new TypeError("string-remove-thousand-separators/remSep(): [THROW_ID_01] Input must be string! Currently it's: ".concat(typeof e, ", equal to:\n").concat(JSON.stringify(e, null, 4)));
    if (r && "object" != typeof r) throw new TypeError("string-remove-thousand-separators/remSep(): [THROW_ID_02] Options object must be a plain object! Currently it's: ".concat(typeof r, ", equal to:\n").concat(JSON.stringify(r, null, 4)));
    var o = _objectSpread({
        removeThousandSeparatorsFromNumbers: !0,
        padSingleDecimalPlaceNumbers: !0,
        forceUKStyle: !1
      }, r),
      a = x(e.trim(), '"');
    if ("" === a) return a;
    var u = new f();
    for (var _e4 = 0, _r3 = a.length; _e4 < _r3; _e4++) {
      if (o.removeThousandSeparatorsFromNumbers && "" === a[_e4].trim() && u.add(_e4, _e4 + 1), o.removeThousandSeparatorsFromNumbers && "'" === a[_e4] && (u.add(_e4, _e4 + 1), "'" === a[_e4 + 1])) {
        t = !1;
        break;
      }
      if (n.includes(a[_e4])) {
        if (void 0 !== a[_e4 + 1] && /^\d*$/.test(a[_e4 + 1])) if (void 0 !== a[_e4 + 2]) {
          if (!/^\d*$/.test(a[_e4 + 2])) {
            t = !1;
            break;
          }
          if (void 0 !== a[_e4 + 3]) {
            if (!/^\d*$/.test(a[_e4 + 3])) {
              t = !1;
              break;
            }
            if (void 0 !== a[_e4 + 4] && /^\d*$/.test(a[_e4 + 4])) {
              t = !1;
              break;
            }
            if (o.removeThousandSeparatorsFromNumbers && u.add(_e4, _e4 + 1), i) {
              if (a[_e4] !== i) {
                t = !1;
                break;
              }
            } else i = a[_e4];
          } else o.removeThousandSeparatorsFromNumbers && o.forceUKStyle && "," === a[_e4] && u.add(_e4, _e4 + 1, ".");
        } else o.forceUKStyle && "," === a[_e4] && u.add(_e4, _e4 + 1, "."), o.padSingleDecimalPlaceNumbers && u.add(_e4 + 2, _e4 + 2, "0");
      } else if (!/^\d*$/.test(a[_e4])) {
        t = !1;
        break;
      }
    }
    return t && u.current() ? function (e, r, t) {
      var n,
        i = 0,
        o = 0;
      if (0 === arguments.length) throw new Error("ranges-apply: [THROW_ID_01] inputs missing!");
      if ("string" != typeof e) throw new TypeError("ranges-apply: [THROW_ID_02] first input argument must be a string! Currently it's: ".concat(typeof e, ", equal to: ").concat(JSON.stringify(e, null, 4)));
      if (r && !Array.isArray(r)) throw new TypeError("ranges-apply: [THROW_ID_03] second input argument must be an array (or null)! Currently it's: ".concat(typeof r, ", equal to: ").concat(JSON.stringify(r, null, 4)));
      if (t && "function" != typeof t) throw new TypeError("ranges-apply: [THROW_ID_04] the third input argument must be a function (or falsey)! Currently it's: ".concat(typeof t, ", equal to: ").concat(JSON.stringify(t, null, 4)));
      if (!r || !r.filter(function (e) {
        return e;
      }).length) return e;
      n = Array.isArray(r) && Number.isInteger(r[0]) && Number.isInteger(r[1]) ? [Array.from(r)] : Array.from(r);
      var a = n.length;
      var u = 0;
      n.filter(function (e) {
        return e;
      }).forEach(function (e, r) {
        if (t && (i = Math.floor(u / a * 10), i !== o && (o = i, t(i))), !Array.isArray(e)) throw new TypeError("ranges-apply: [THROW_ID_05] ranges array, second input arg., has ".concat(r, "th element not an array: ").concat(JSON.stringify(e, null, 4), ", which is ").concat(typeof e));
        if (!Number.isInteger(e[0])) {
          if (!Number.isInteger(+e[0]) || +e[0] < 0) throw new TypeError("ranges-apply: [THROW_ID_06] ranges array, second input arg. has ".concat(r, "th element, array ").concat(JSON.stringify(e, null, 0), ". Its first element is not an integer, string index, but ").concat(typeof e[0], ", equal to: ").concat(JSON.stringify(e[0], null, 4), "."));
          n[r][0] = +n[r][0];
        }
        if (!Number.isInteger(e[1])) {
          if (!Number.isInteger(+e[1]) || +e[1] < 0) throw new TypeError("ranges-apply: [THROW_ID_07] ranges array, second input arg. has ".concat(r, "th element, array ").concat(JSON.stringify(e, null, 0), ". Its second element is not an integer, string index, but ").concat(typeof e[1], ", equal to: ").concat(JSON.stringify(e[1], null, 4), "."));
          n[r][1] = +n[r][1];
        }
        u += 1;
      });
      var l = s(n, {
          progressFn: function progressFn(e) {
            t && (i = 10 + Math.floor(e / 10), i !== o && (o = i, t(i)));
          }
        }),
        f = Array.isArray(l) ? l.length : 0;
      if (f > 0) {
        var _r4 = e.slice(l[f - 1][1]);
        e = l.reduce(function (r, n, s, a) {
          return t && (i = 20 + Math.floor(s / f * 80), i !== o && (o = i, t(i))), r + e.slice(0 === s ? 0 : a[s - 1][1], a[s][0]) + (a[s][2] || "");
        }, ""), e += _r4;
      }
      return e;
    }(a, u.current()) : a;
  }, e.version = "5.1.0", Object.defineProperty(e, "__esModule", {
    value: !0
  });
});